import { Action, Approver, ResourceType, UserSubType } from './common';
import type { SignatureType } from './signing';
import { User } from './user';

export enum ApprovalDecision {
  NO_VOTE = 0,
  APPROVE = 1,
  REJECT = 2,
  ABSTAIN = 3,
  ASK_FOR_INFO = 4,
}

export enum SignatureRequestUserStatus {
  CURRENT = 0,
  PENDING = 1,
}

export interface DownloadAction {
  action: Action;
  firstDownload: number;
  lastDownload: number;
  counter: number;
}

export interface ApprovalUserLog {
  rid: number;
  fileName: string;
  version: number;
  decision: ApprovalDecision;
  comment: string;
  updateDate: number;
  status: number;
  format: string;
  secView: boolean;
  secViewPending: boolean;
  signature: boolean;
  deleted: boolean;
  type?: ResourceType;
  name?: string;
  voteDate?: number;
  subtype?: number;
  optionId?: number;
  optionText?: string;
  signedFile?: boolean;
  signedFileValidityLevel?: number;
  approvalSignature?: SignatureType | 0;
}

export interface DownloadInfo {
  userId: number;
  userDisplayName: string;
  userShortName: string;
  userImage: string;
  userSubtype: UserSubType;
  actions: DownloadAction[];
}

export interface DownloadInfoMap {
  version: number;
  stats: DownloadInfo[];
}

export interface ApproverVoteUser extends Approver {
  type: ResourceType.USER;
  decision: ApprovalDecision;
  comment: string;
  updateDate: number;
  signature: boolean;
}

export interface ApproverVoteGroup extends Approver {
  type: ResourceType.GROUP;
  membersVote: ApproverVoteUser[];
}

export interface FileVersionSendReceipt {
  rid: number;
  version: number;
  userId: number;
  user: User;
  recipient: string;
  messageId: string;
  muc: string;
  status: string;
  readDate: number;
  egov: boolean;
}

export interface ApprovalLogStats {
  approved: number;
  rejected: number;
  abstained: number;
  pending: number;
}

export interface ApprovalLog {
  votes: (ApproverVoteUser | ApproverVoteGroup)[];
  stats: ApprovalLogStats;
  status: number;
  lastUpdate: number;
  approval?: number;
}

export interface VisibleSignature {
  w: number;
  h: number;
  p: number;
  ph: number;
  pw: number;
  x: number;
  y: number;
  field?: string;
  image?: string;
  showDate?: boolean;
  locality?: string;
  skipZoom?: boolean;
  pdfALevel?: string;
}

export interface SigningVoteBody {
  decision: ApprovalDecision;
  comment: string;
  visibleSignature?: VisibleSignature;
}
